package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.*

class GeoRepository(private val httpClient: HttpClient) {
    suspend fun getGeo(workplaceId: Long): Result<WorkplaceGeoDto?> = runCatching {
        httpClient.get("workplaces/$workplaceId/geo").body()
    }

    suspend fun updateGeo(workplaceId: Long, req: UpdateWorkplaceGeoRequest): Result<Unit> = runCatching {
        httpClient.put("workplaces/$workplaceId/geo") { setBody(req) }
    }

    suspend fun geoCheckIn(req: GeoCheckInRequest): Result<Unit> = runCatching {
        httpClient.post("attendance/geo-check-in") { setBody(req) }
    }
}
